/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * StavertonAPI
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  LookupAvailabilityParams,
  LookupBarcodeParams,
  MultiRetailAvailabilityLookupResponse,
  MultiRetailProductLookupResponse
} from './index.schemas';

import { useCustomInstance } from '../staverton.openapi.axios';





export const useLookupBarcodeHook = () => {
        const lookupBarcode = useCustomInstance<MultiRetailProductLookupResponse>();

        return useCallback((
    params?: LookupBarcodeParams,
 signal?: AbortSignal
) => {
        return lookupBarcode(
          {url: `/OpenRetail/LookupBarcode`, method: 'GET',
        params, signal
    },
          );
        }, [lookupBarcode])
      }
    

export const getLookupBarcodeQueryKey = (params?: LookupBarcodeParams,) => {
    return [`/OpenRetail/LookupBarcode`, ...(params ? [params]: [])] as const;
    }

    
export const useLookupBarcodeQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useLookupBarcodeHook>>>, TError = unknown>(params?: LookupBarcodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLookupBarcodeHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLookupBarcodeQueryKey(params);

  const lookupBarcode =  useLookupBarcodeHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useLookupBarcodeHook>>>> = ({ signal }) => lookupBarcode(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLookupBarcodeHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LookupBarcodeQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useLookupBarcodeHook>>>>
export type LookupBarcodeQueryError = unknown


export function useLookupBarcode<TData = Awaited<ReturnType<ReturnType<typeof useLookupBarcodeHook>>>, TError = unknown>(
 params: undefined |  LookupBarcodeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLookupBarcodeHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useLookupBarcodeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useLookupBarcodeHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLookupBarcode<TData = Awaited<ReturnType<ReturnType<typeof useLookupBarcodeHook>>>, TError = unknown>(
 params?: LookupBarcodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLookupBarcodeHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useLookupBarcodeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useLookupBarcodeHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLookupBarcode<TData = Awaited<ReturnType<ReturnType<typeof useLookupBarcodeHook>>>, TError = unknown>(
 params?: LookupBarcodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLookupBarcodeHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLookupBarcode<TData = Awaited<ReturnType<ReturnType<typeof useLookupBarcodeHook>>>, TError = unknown>(
 params?: LookupBarcodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLookupBarcodeHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useLookupBarcodeQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useLookupAvailabilityHook = () => {
        const lookupAvailability = useCustomInstance<MultiRetailAvailabilityLookupResponse>();

        return useCallback((
    params?: LookupAvailabilityParams,
 signal?: AbortSignal
) => {
        return lookupAvailability(
          {url: `/OpenRetail/LookupAvailability`, method: 'GET',
        params, signal
    },
          );
        }, [lookupAvailability])
      }
    

export const getLookupAvailabilityQueryKey = (params?: LookupAvailabilityParams,) => {
    return [`/OpenRetail/LookupAvailability`, ...(params ? [params]: [])] as const;
    }

    
export const useLookupAvailabilityQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useLookupAvailabilityHook>>>, TError = unknown>(params?: LookupAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLookupAvailabilityHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLookupAvailabilityQueryKey(params);

  const lookupAvailability =  useLookupAvailabilityHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useLookupAvailabilityHook>>>> = ({ signal }) => lookupAvailability(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLookupAvailabilityHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LookupAvailabilityQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useLookupAvailabilityHook>>>>
export type LookupAvailabilityQueryError = unknown


export function useLookupAvailability<TData = Awaited<ReturnType<ReturnType<typeof useLookupAvailabilityHook>>>, TError = unknown>(
 params: undefined |  LookupAvailabilityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLookupAvailabilityHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useLookupAvailabilityHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useLookupAvailabilityHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLookupAvailability<TData = Awaited<ReturnType<ReturnType<typeof useLookupAvailabilityHook>>>, TError = unknown>(
 params?: LookupAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLookupAvailabilityHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useLookupAvailabilityHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useLookupAvailabilityHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLookupAvailability<TData = Awaited<ReturnType<ReturnType<typeof useLookupAvailabilityHook>>>, TError = unknown>(
 params?: LookupAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLookupAvailabilityHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLookupAvailability<TData = Awaited<ReturnType<ReturnType<typeof useLookupAvailabilityHook>>>, TError = unknown>(
 params?: LookupAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLookupAvailabilityHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useLookupAvailabilityQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



